function TrackingPage() {
    return (
        <div>
            TrackingPage
        </div>
    );
}

export default TrackingPage;
